<table fd-table class="atom-table" [noBorderX]="true">
  <thead fd-table-header>
    <tr fd-table-row class="atom-table-row">
      <th fd-table-cell>
        <div>
          <span>{{ "Name" | uppercase }}</span>
        </div>
      </th>
      <th fd-table-cell>
        <div>
          <span>{{ "Type" | uppercase }}</span>
        </div>
      </th>
      <th fd-table-cell>
        <div>
          <span>{{ "Value" | uppercase }}</span>
        </div>
      </th>
    </tr>
  </thead>

  <tbody fd-table-body [noBorderX]="true" [noBorderY]="true">
    @for (index of indices; track index) {
      <tr fd-table-row class="atom-table-row">
        <td fd-table-cell>
          <span>{{ index.name }}</span>
        </td>
        <td fd-table-cell>
          <span>{{ Object.keys(index.valueFrom)[0] }}</span>
        </td>
        <td fd-table-cell>
          <span>{{ Object.values(index.valueFrom)[0] }}</span>
        </td>
      </tr>
    }
  </tbody>
</table>
